import React from 'react';
import { connect } from 'react-redux';
import FilterGroup from './FilterGroup';
import FilterCheckboxes from './FilterCheckboxes';

const orientationOptions = [
  {
    name: 'landscape',
    displayName: 'Landscape',
  },
  {
    name: 'portrait',
    displayName: 'Portrait',
  },
];
const usageOptions = [
  {
    name: 'creative',
    displayName: 'Creative',
  },
  {
    name: 'editorial',
    displayName: 'Editorial',
  },
];

const PhotoFilters = ({ open }) => (
  <FilterGroup className="photos" name="Photo" open={open}>
    <FilterCheckboxes legend="Orientation" filterKey="photo" options={orientationOptions}/>
    <FilterCheckboxes legend="Usage" filterKey="photo" options={usageOptions}/>
  </FilterGroup>
);

const mapStateToProps = ({ search: searchStore }) => ({
  open: searchStore.filters.media.photo,
});

export default connect(mapStateToProps)(PhotoFilters);
